var _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22833 9.91018C7.51477 9.91018 7.74699 9.68792 7.74699 9.41375V2.15091L8.90921 3.44869C9.09558 3.65686 9.42303 3.68096 9.64052 3.50253C9.85802 3.32411 9.88319 3.01071 9.69675 2.80254L7.6221 0.485861C7.52362 0.375825 7.37971 0.3125 7.22833 0.3125C7.07695 0.3125 6.93304 0.375825 6.83456 0.485861L4.75989 2.80254C4.57346 3.01071 4.59865 3.32411 4.81614 3.50253C5.03363 3.68096 5.36106 3.65686 5.54748 3.44869L6.70967 2.15091V9.41375C6.70967 9.68792 6.94189 9.91018 7.22833 9.91018Z",
    fill: "url(#paint0_linear_26286_40905)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99407 5.44141C9.50847 5.44141 9.26566 5.44141 9.09126 5.55294C9.01574 5.60124 8.95087 5.66331 8.90046 5.7356C8.78386 5.90254 8.78386 6.13496 8.78386 6.59975V9.41286C8.78386 10.2354 8.08726 10.9022 7.22787 10.9022C6.36856 10.9022 5.67192 10.2354 5.67192 9.41286V6.59975C5.67192 6.13496 5.67192 5.90252 5.55535 5.73556C5.50491 5.6633 5.44009 5.60126 5.36459 5.55297C5.19016 5.44141 4.94733 5.44141 4.46168 5.44141C2.50568 5.44141 1.52768 5.44141 0.920029 6.02301C0.312378 6.60465 0.312378 7.54059 0.312378 9.41273V10.0746C0.312378 11.9468 0.312378 12.8829 0.920029 13.4645C1.52768 14.0461 2.50568 14.0461 4.46168 14.0461H9.99407C11.9501 14.0461 12.928 14.0461 13.5357 13.4645C14.1434 12.8829 14.1434 11.9468 14.1434 10.0746V9.41273C14.1434 7.54059 14.1434 6.60465 13.5357 6.02301C12.928 5.44141 11.9501 5.44141 9.99407 5.44141Z",
    fill: "url(#paint1_linear_26286_40905)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26286_40905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3437 17.6876C10.9446 17.6876 8.99988 15.7429 8.99988 13.3438C8.99988 10.9447 10.9446 9 13.3437 9C15.7428 9 17.6875 10.9447 17.6875 13.3438C17.6875 15.7429 15.7428 17.6876 13.3437 17.6876Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0612 12.7435L12.6965 11.9208C13.1071 11.389 13.3125 11.1231 13.504 11.1793C13.6956 11.2355 13.6956 11.5616 13.6956 12.2138V12.2753C13.6956 12.5106 13.6956 12.6282 13.7741 12.702L13.7783 12.7058C13.8585 12.778 13.9864 12.778 14.2422 12.778C14.7026 12.778 14.9327 12.778 15.0105 12.9116C15.0118 12.9138 15.0131 12.9161 15.0143 12.9183C15.0877 13.054 14.9544 13.2266 14.6879 13.5718L14.0526 14.3945C13.642 14.9262 13.4366 15.1921 13.2451 15.1359C13.0535 15.0797 13.0535 14.7536 13.0535 14.1014L13.0535 14.0399C13.0535 13.8047 13.0535 13.687 12.975 13.6132L12.9708 13.6094C12.8906 13.5372 12.7627 13.5372 12.5069 13.5372C12.0466 13.5372 11.8164 13.5372 11.7386 13.4036C11.7373 13.4014 11.7361 13.3991 11.7348 13.3969C11.6614 13.2612 11.7947 13.0886 12.0612 12.7435Z",
    fill: "url(#paint2_linear_26286_40905)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26286_40905",
    x: 5.17098,
    y: 5.1711,
    width: 16.3454,
    height: 16.3453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.91445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_40905"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_40905",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26286_40905",
    x1: 4.63501,
    y1: 1.06232,
    x2: 11.9003,
    y2: 4.62374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26286_40905",
    x1: 0.312378,
    y1: 6.11365,
    x2: 7.99967,
    y2: 17.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26286_40905",
    x1: 11.7148,
    y1: 11.4821,
    x2: 15.3769,
    y2: 14.2586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportCreate);
export default __webpack_public_path__ + "static/media/import-create.7ab6b83202e564833c12578f743acb03.svg";
export { ForwardRef as ReactComponent };